import React from "react";
import { retrieveLaunchParams } from "@telegram-apps/bridge";

import { RetrieveLPResult } from "@telegram-apps/bridge";

export const LaunchParamsContext = React.createContext<RetrieveLPResult | null>(retrieveLaunchParams());
